export enum ReportKinds {
  ENTRY = "ENTRY",
  ENTRY_LEAD = "ENTRY_LEAD",
  ENTRY_CONTACT = "ENTRY_CONTACT",
  ENTRY_JUNK = "ENTRY_JUNK",
  DEAL = "DEAL",
  DEAL_WON = "DEAL_WON",
  DEAL_LOST = "DEAL_LOST",
  DEAL_TO_COMPETITION = "DEAL_TO_COMPETITION",
  TASK = "TASK",
  TASK_COMPLETED = "TASK_COMPLETED",
  TASK_PENDING = "TASK_PENDING",
}
